var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 47,
    viewBox: "0 0 52 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdd_6236_53664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4.00195,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7024 22.3173C39.7024 21.3956 39.6207 20.5206 39.4807 19.6689H26.2974V24.9306H33.8457C33.5074 26.6573 32.5157 28.1156 31.0457 29.1073V32.6073H35.549C38.1857 30.1689 39.7024 26.5756 39.7024 22.3173Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2963 36.0022C30.0763 36.0022 33.2379 34.7422 35.5479 32.6072L31.0446 29.1072C29.7846 29.9472 28.1863 30.4605 26.2963 30.4605C22.6446 30.4605 19.5529 27.9988 18.4446 24.6738H13.8013V28.2788C16.0996 32.8522 20.8246 36.0022 26.2963 36.0022Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4457 24.6739C18.154 23.8339 18.0024 22.9356 18.0024 22.0022C18.0024 21.0689 18.1657 20.1706 18.4457 19.3306V15.7256H13.8024C12.8457 17.6156 12.2974 19.7389 12.2974 22.0022C12.2974 24.2656 12.8457 26.3889 13.8024 28.2789L18.4457 24.6739Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2963 13.5436C28.3613 13.5436 30.2046 14.2553 31.6629 15.6436L35.6529 11.6536C33.2379 9.39029 30.0763 8.00195 26.2963 8.00195C20.8246 8.00195 16.0996 11.152 13.8013 15.7253L18.4446 19.3303C19.5529 16.0053 22.6446 13.5436 26.2963 13.5436Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdd_6236_53664",
    x: -2,
    y: -5.99805,
    width: 56,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6236_53664"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0862745 0 0 0 0 0.0980392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_6236_53664",
    result: "effect2_dropShadow_6236_53664"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0862745 0 0 0 0 0.0980392 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_6236_53664",
    result: "effect3_dropShadow_6236_53664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_6236_53664",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.5dce024b2856aae6417da4cc061752b3.svg";
export { ForwardRef as ReactComponent };